import { gql } from '@apollo/client';

export const ALL_ADMIN_PORTAL_USERS = gql`
  query AllAdminPortalUsers($input: UserFilterInput) {
    users: allAdminPortalUsers(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          firstName
          lastName
          email
          status
        }
      }
    }
  }
`;
